import React, { useState } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';

// Import required modules
import { FreeMode, Navigation, Thumbs } from 'swiper/modules';

const ProductSlider = ({ images }) => {
  const baseUrl = "https://backend.tokoyarn.com/public/";
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const images_data = JSON.parse(images);
  console.log("images::", images);
  console.log("images prop type:", typeof images_data, "images value:", images_data);

  return (
    <>
      <Swiper
        style={{
          '--swiper-navigation-color': '#fff',
          '--swiper-pagination-color': '#fff',
        }}
        spaceBetween={10}
        navigation={true}
        thumbs={{ swiper: thumbsSwiper }}
        modules={[FreeMode, Navigation, Thumbs]}
        className="mySwiper2"
      >
        {console.log("Testtt",images)}
        {images_data.map((image, index) => (
          <SwiperSlide key={index}>
            <img src={`${baseUrl+image}`} alt={`Product Slide ${index + 1}`} />
            
          </SwiperSlide>
        ))}
      </Swiper>
      <Swiper
        onSwiper={setThumbsSwiper}
        spaceBetween={10}
        slidesPerView={4}
        freeMode={true}
        watchSlidesProgress={true}
        modules={[FreeMode, Navigation, Thumbs]}
        className="mySwiper"
      >
        {images_data.map((image, index) => (
          <SwiperSlide key={index}>
            <img src={`${baseUrl+image}`} alt={`Thumbnail Slide ${index + 1}`} />
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
};

export default ProductSlider;